// src/components/admin/sidebar/AdminSidebar.jsx
import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  FiGrid,
  FiTool,
  FiClipboard,
  FiDollarSign,
  FiSettings,
  FiLogOut,
  FiStar,
  FiChevronDown,
  FiChevronUp,
  FiSave,
  FiBell,
  FiHeadphones,
  FiMessageSquare
} from "react-icons/fi";
import { FaEdit } from 'react-icons/fa';
import { Modal } from "react-bootstrap";
import { FaTractor, FaSignOutAlt, FaTimes } from "react-icons/fa";
import "../../../assets/css/equipmentrentaladmin/adminsidebar/AdminSidebar.css";
import AppContext from "../../../context/AppContext";

const RentalAdminSidebar = ({ isOpen, onClose }) => {
  const { setLoggedInRental, setAuthToken, setIsLoggedIn, baseUrl, authToken, loggedInRental } = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!loggedInRental?.id) return;

    const fetchUnreadCount = () => {
      axios
        .post(
          `${baseUrl}/rentaladmin/notifications/getUnreadCount`,
          { srrentaladmin_id: loggedInRental.id },
          { headers: { Authorization: `Bearer ${authToken}` } }
        )
        .then((res) => {
          if (res.data.success) setUnreadCount(res.data.count);
        })
        .catch(() => {});
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 20000);
    return () => clearInterval(interval);
  }, [loggedInRental, baseUrl, authToken]);

  const menu = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <FiGrid />,
      path: '/rental-admin/dashboard'
    },
    {
      id: 'my equipment',
      label: 'My Equipment',
      icon: <FiTool />,
      path: '/rental-admin/myequipment'
    },
    {
      id: 'rentals',
      label: 'MY Rental Request',
      icon: < FiClipboard />,
      path: '/rental-admin/rentals'
    },
    {
      id: 'maintenance',
      label: 'Maintenance Request',
      icon: <FiSave />,
      path: '/rental-admin/maintenance'
    },
    {
      id: 'messages',
      label: 'Messages',
      icon: <FiMessageSquare />,
      path: '/rental-admin/messages'
    },
    // {
    //   id: 'blogs',
    //   label: 'Blogs',
    //   icon: <FaEdit />,
    //   path: '/rental-admin/blogs'
    // },
    {
      id: 'earnings',
      label: 'Earnings',
      icon: <FiDollarSign />,
      path: '/rental-admin/earnings'
    },
    {
      id: 'reviews',
      label: 'Reviews & Ratings',
      icon: <FiStar />,
      path: '/rental-admin/reviews'
    },
    {
      id: 'rentaldispute',
      label: 'Dispute',
      icon: <FiHeadphones />,
      path: '/rental-admin/rentaldispute'
    },
    {
      id: 'notification',
      label: 'Notification',
      icon: <FiBell />,
      path: '/rental-admin/notification'
    },
    // {
    //   id: 'support',
    //   label: 'Support',
    //   icon: <FiHeadphones/>,
    //   path: '/rental-admin/support'
    // },

    // { 
    //   id: 'settings',
    //   label: 'Settings',
    //    icon: <FiSettings />, 
    //    path: '/rental-admin/settings' }
  ];


  const handleNavigation = (path) => {
    navigate(path);
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };


  const [show, setShow] = useState(false);
  const handleLogout = () => {
    localStorage.clear();      // clear admin data
    navigate("/rental-admin/registration"); // rental admin login page
  };


  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  

  const Logout = () => {

    localStorage.removeItem("rentalEmail");
    localStorage.removeItem("rentalPassword");
    localStorage.removeItem("LoggedInRental");
    localStorage.removeItem("authToken");

    setLoggedInRental(null);
    setAuthToken(null);
    setIsLoggedIn(false);

    navigate("/rental-admin/login");
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="rental-sidebar-overlay" onClick={onClose}></div>
      )}

      <aside className={`rental-smart-agri-sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo & Brand Section */}
        <div className="rental-sidebar-brand">
          <div className="rental-sidebar-logo">
            <FaTractor size={32} />
          </div>
          <div className="rental-sidebar-brand-text">
            <h3 className="rental-sidebar-brand-title">Smart Agri</h3>
            <span className="rental-sidebar-brand-subtitle">RENT</span>
          </div>
        </div>

        {/* Admin Profile */}
        {/* <div className="rental-sidebar-profile">
            <div className="rental-sidebar-avatar">R</div>
            <div className="rental-sidebar-profile-text">
              <h4 className="rental-sidebar-profile-name">Rental Admin Panel</h4>
              <span className="rental-sidebar-profile-email">rentaladmin@smartagrirent.com</span>
            </div>
          </div> */}

        {/* Navigation Menu */}
        <nav className="rental-sidebar-menu">
          {menu.map((item) => (
            <div key={item.path}>
              <button
                className={`rental-sidebar-menu-item ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => {
                  if (item.hasSubmenu) {
                    handleUserMenuToggle();
                  } else {
                    handleNavigation(item.path);
                  }
                }}
              >
                <span className="rental-menu-icon">{item.icon}</span>
                <span className="rental-menu-label">{item.label}</span>
                {item.id === "notification" && unreadCount > 0 && (
                  <span
                    style={{
                      marginLeft: "auto",
                      background: "#FDB714",
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 700,
                      borderRadius: "999px",
                      minWidth: "20px",
                      height: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 6px",
                    }}
                  >
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
                {item.hasSubmenu && (
                  <span className="rental-menu-chevron">
                    {isUserMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </button>

              {/* Submenu */}
              {item.submenu && isUserMenuOpen && (
                <div className="rental-sidebar-submenu">
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.path}
                      className={`rental-sidebar-submenu-item ${location.pathname === sub.path ? 'active' : ''}`}
                      onClick={() => handleNavigation(sub.path)}
                    >
                      <span className="rental-submenu-dot">•</span>
                      <span>{sub.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Logout Button */}
        {/* Logout Button */}
        <button className="rental-logout-btn" onClick={Logout}>
          <FaSignOutAlt />
          Logout
        </button>

        {/* Confirm Logout Modal */}
        <Modal show={show} onHide={() => setShow(false)} centered>
          <div className="logout-modal">

            <div className="logout-header">
              <h4>Confirm Logout</h4>
              <FaTimes className="close-icon" onClick={() => setShow(false)} />
            </div>

            <div className="logout-body">
              <div className="logout-icon-wrapper">
                <FaSignOutAlt className="modal-logout-icon" />
              </div>
              <p>Are you sure you want to logout from Rental Admin Panel?</p>
            </div>

            <div className="logout-footer">
              <button className="cancel-btn" onClick={() => setShow(false)}>
                Cancel
              </button>
              <button className="confirm-btn" onClick={handleLogout}>
                Yes, Logout
              </button>
            </div>

          </div>
        </Modal>

      </aside>
    </>
  );
};


export default RentalAdminSidebar;